// extracted by mini-css-extract-plugin
export default {"wrapper":"gg7sX9e","container":"v7DKcHG","title":"C3Mf9ZF","tags-box":"g5MnDRn","tagsBox":"g5MnDRn","tag":"oZeYvAD","more-tag":"CiTT-Lt","moreTag":"CiTT-Lt"};